import { Component, OnInit, Inject } from '@angular/core';

import {MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ServicepoolService } from '../services/servicepool.service';

import { ReponseWebService } from '../datastruct/Meloyi.module';


export interface DialogData {
  assurName : string; 
  categs: any[];
  policy: boolean;
}


@Component({
  selector: 'app-addbigcateg',
  templateUrl: './addbigcateg.component.html',
  styleUrls: ['./addbigcateg.component.css']
})
export class AddbigcategComponent implements OnInit {

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  eltsType = [] ;

  saveBtnState = "done_all" ;

  primenameedit = "edit" ;

  baseElement = "" ;

  editprimename = 0 ;

  configPrimeBtn = false ;

  primeconfigObject : any ;


  eltName = "" ;

  allCategs = [] ;

  newCateg = "" ;

  Tabval = "";

  policy = false ;
 
  headClass = "card-header card-header-tabs card-header-primary" ;


  categ: string ; 
  denommination: string ;  
  abreviation: string ;
  description : string ;


  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 2 ;

  nomAssurance = "" ;
  orignnomAssurance = "" ;

  choosenInsuranceType : any ;

  constructor(private dialogRef: MatDialogRef<AddbigcategComponent>,  @Inject(MAT_DIALOG_DATA) public data: any,public dialog: MatDialog,  private configServer: ServicepoolService ){ 

  	this.choosenInsuranceType = data ;
  }

  ngOnInit(){
    var onChunkArray = [] ;
    var index = 0 ;
    this.resultArray = this.allCategs.reduce((indexDead, item ) => {
    const chunkIndex = Math.floor(index/this.subTabLength)

    if(!onChunkArray[chunkIndex]) {
    onChunkArray[chunkIndex] = [] // start a new chunk
    }

    onChunkArray[chunkIndex].push(item) ;

    index++ ;

    return onChunkArray ;
    }, []) ;

    if(this.allCategs.length==1 && this.allCategs[0].nomFrmt=="AucuneDistinction"){
      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;
      this.eltsType.push([]) ;
    }
    else{
      for (var i = 0; i< this.allCategs.length; i++) {
        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        this.eltsType.push([]) ;
      }  
    }
  }



  onBtnClick(returnedValue): void {
    if(returnedValue=="-")
      this.dialogRef.close(returnedValue);
    else
      this.dialogRef.close(this.nomAssurance);
  }

  soppiMbirrMi(domaine){

    this.Tabval = (this.Tabval==this.eltName)? "-":this.eltName ;
  }

  editPrime(){
    if(this.editprimename==0){
      this.editprimename = 1 ;
      this.primenameedit = "done";      
    }else{
      this.editprimename = 0 ;
      this.primenameedit = "edit";            
    }
  }

  deletePrime(){
  }


  ajouterCateg(){

    if (this.newCateg != "" && this.saveBtnState=="done_all"){

      let theCreatedType = this.newCateg  ;

      this.allCategs.push( theCreatedType ) ;

      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;

      var onChunkArray = [] ;

      var index = 0 ;

      this.resultArray = this.allCategs.reduce((indexDead, item ) => { 
        const chunkIndex = Math.floor(index/this.subTabLength) ;

        if(!onChunkArray[chunkIndex]) {
          onChunkArray[chunkIndex] = [] ; 
        }

        onChunkArray[chunkIndex].push(item) ;
        index++ ;
        return onChunkArray ;
      }, []) ; 

      this.newCateg = "" ;
    }
  }


  onCategChoose(event, i, j) {
    if (event.target.checked){
      this.checkStatus[j+2*i]=true ;
      var typeIndex = j+2*i ;
    }
    else{
        console.log("UNCHECKED "+event.target.value) ;
        this.checkStatus[j+2*i]=false ;      
    }
  }


  saveBigCateg(){

  	let theNewBigCateg = {"categ":this.categ,
  							 "denommination":this.denommination,
  							  "abreviation":this.abreviation,
  							   "description":this.description,
  							    "soustype":JSON.stringify(this.allCategs) } ;

    this.configServer.addNewBigCateg("smcbyn", this.choosenInsuranceType, theNewBigCateg ).then( (retourbi) => {
        var statutrec = retourbi.statutreq ;
        var message = retourbi.message ;
        if(statutrec==1){
          console.log("Done. Param Added") ;
	      this.dialogRef.close();
        }
        else
          console.log("Failed") ;
    }) ;                      
  }


  savePrime(){
  	if(this.categ!==undefined && this.denommination!==undefined && this.abreviation!==undefined && this.description!==undefined){
		this.saveBigCateg() ;
  	}else{
  		alert("Veuillez remplir tous les champs") ;
  	}
  }


  callConfirmDialog(){

    var data = {"title": "Supprimer Assurance", "message": "Voulez-vous vraiment supprimer cette Prime ?"} ;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
        return true ;
      }
      else{
        return false ;        
      }
    });
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


  setPolicy(){
      var data = {"title": "Confirmation", "message": "Voulez-vous restreindre l'utilisation de cette configuration à l'analyse  ?"} ;
      const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
      dialogRef1.afterClosed().subscribe(result => {
        console.log(result) ;
        if(result=="dlt"){

            this.configServer.updatePolicy(1, this.formatThisString(this.orignnomAssurance), true ).then( (retourbi) => {
                var statutrec = retourbi.statutreq ;
                var message = retourbi.message ;
                console.log(retourbi) ;

                if(statutrec==1){
                  this.policy = true ;
                  console.log("Done") ;
                }
                else
                  console.log("Failed") ;
            }) ;                      
        }
        else{
          this.policy = false ;
          console.log("") ;
        }
      });
  }

  releasePolicy(){
    var data = {"title": "Confirmation", "message": "Voulez-vous vraiment rendre cette configuration utilisable par les agences ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){

          this.configServer.updatePolicy(1, this.formatThisString(this.orignnomAssurance), false ).then( (retourbi) => {
              var statutrec = retourbi.statutreq ;
              var message = retourbi.message ;
              console.log(retourbi) ;

              if(statutrec==1){
                this.policy = false ;
                console.log("Done") ;
              }
              else
                console.log("Failed") ;
          }) ;                      
      }
      else{
        this.policy = true ;
        console.log("") ;
      }
    });
  }

}
